import { render, staticRenderFns } from "./FavouriteScenario.vue?vue&type=template&id=3c449492&scoped=true&"
import script from "./FavouriteScenario.vue?vue&type=script&lang=js&"
export * from "./FavouriteScenario.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteScenario.vue?vue&type=style&index=0&id=3c449492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c449492",
  null
  
)

export default component.exports